module.exports = __webpack_public_path__ + "static/media/21ECLAC9.bf07f153.jpg";